import { useEffect } from 'react';
import { useDocument } from '../hooks/useDocument.js';
export function useOnClickOutside(ref, handler) {
    const { document } = useDocument();
    useEffect(() => {
        const listener = event => {
            let inside;
            if (event.composedPath) {
                inside = event.composedPath().indexOf(ref === null || ref === void 0 ? void 0 : ref.current) !== -1;
            }
            else {
                inside =
                    !document.documentElement.contains(event.target) ||
                        (ref === null || ref === void 0 ? void 0 : ref.current.contains(event.target));
            }
            if (!inside) {
                handler === null || handler === void 0 ? void 0 : handler(event);
            }
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler]);
}
//# sourceMappingURL=useOnClickOutside.js.map